import { Target, Eye } from "@phosphor-icons/react";

const ABOUT_IMAGE = "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/rc3u1fy5_94075014-9B7D-4319-8867-96DEB8F21EF6.PNG";

export function AboutSection() {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="section-padding bg-[#0F172A] relative overflow-hidden noise-overlay"
    >
      {/* Background Accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#C92127]/10 to-transparent" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="space-y-12 text-white">
            {/* Overline */}
            <div className="flex items-center gap-3">
              <span className="w-12 h-0.5 bg-[#C92127]" />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
                Quiénes Somos
              </span>
            </div>

            {/* Title */}
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight">
              Construimos <span className="text-[#C92127]">confianza</span> mediante trabajo bien hecho
            </h2>

            {/* Intro */}
            <p className="text-lg text-slate-300 leading-relaxed">
              En SEINMAR S.A.S. desarrollamos soluciones integrales para instalaciones 
              comerciales e industriales, combinando experiencia operativa, capacidad 
              de respuesta y altos estándares técnicos en cada proyecto.
            </p>

            {/* Mission & Vision */}
            <div className="grid md:grid-cols-2 gap-8">
              {/* Mission */}
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-lg bg-[#C92127]/20 flex items-center justify-center">
                    <Target size={24} weight="duotone" className="text-[#C92127]" />
                  </div>
                  <h3 className="text-xl font-bold">Misión</h3>
                </div>
                <p className="text-slate-400 leading-relaxed">
                  Ser una empresa líder en obra civil y mantenimiento industrial, reconocida 
                  por la calidad de nuestras ejecuciones, la seguridad de nuestros procesos 
                  y la confianza que generamos en cada cliente.
                </p>
              </div>

              {/* Vision */}
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-lg bg-[#1E3A8A]/30 flex items-center justify-center">
                    <Eye size={24} weight="duotone" className="text-blue-400" />
                  </div>
                  <h3 className="text-xl font-bold">Visión</h3>
                </div>
                <p className="text-slate-400 leading-relaxed">
                  Consolidarnos como una de las empresas referentes del mercado local y 
                  regional, destacándonos por nuestro cumplimiento, profesionalismo, 
                  innovación y capacidad de respuesta.
                </p>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-8 pt-8 border-t border-slate-700">
              <div>
                <p className="text-4xl md:text-5xl font-extrabold text-white">50+</p>
                <p className="text-sm text-slate-400 uppercase tracking-wider mt-2">Proyectos Ejecutados</p>
              </div>
              <div>
                <p className="text-4xl md:text-5xl font-extrabold text-[#C92127]">100%</p>
                <p className="text-sm text-slate-400 uppercase tracking-wider mt-2">Cumplimiento</p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-xl overflow-hidden">
              <img
                src={ABOUT_IMAGE}
                alt="Antes y después de proyecto SEINMAR"
                className="w-full h-auto object-contain"
              />
            </div>

            {/* Badge */}
            <div className="absolute -bottom-6 -left-6 bg-[#C92127] text-white p-6 rounded-xl shadow-2xl">
              <p className="text-xs uppercase tracking-[0.2em] mb-1 text-white/80">Resultados</p>
              <p className="text-2xl font-bold">Garantizados</p>
            </div>

            {/* Decorative */}
            <div className="absolute -top-6 -right-6 w-32 h-32 border-2 border-[#C92127]/30 rounded-xl" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
